import * as contentConfiguration from "./configuration";

export { contentConfiguration };
